import React, { useContext } from "react";
import styles from "./LanguagePreference.module.css";
import { Dropdown, TextComponent } from "../../../components";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { LanguageContext } from "../../../utills/LanguageContext";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  // { code: "fr", label: "Français" },
];

const LanguagePreference = () => {
  const { language, changeLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();

  const options = languages.map((lang) => ({
    value: lang.code, 
    label: lang.label,
  }));

  const selectedLang = options.find((opt) => opt.value === language);

  return (
    <div className={styles.AccountContent}>
      {/* <HeadingComponent text="Language Preference" fontSize={20} /> */}
            <TextComponent   text="Language Preference"className={styles.HeadText}/>
      
      <TextComponent text={"language"} divStyle={{marginTop:50}} />

      <Dropdown
        value={selectedLang}
        options={options}
        onChange={(selected) => {
          changeLanguage(selected?.value);
        }}
      />
    </div>
  );
};

export default LanguagePreference;
